<template>
    <div>
        <welcomeModal :settings="welcomeModalSettings"></welcomeModal>
        <div class="helpCenterContent">
            <div class="helpCenterContent__wrapper" @click="showManagePopup">
                <div class="helpCenterContent-icon">
                    <img src="@/assets/icons/helpCenterManage.svg">
                </div>
                <div class="helpCenterContent-text">{{translate('showManagePopupTitle')}}</div>
            </div>
            <div class="helpCenterContent__wrapper" @click="showFeedbackPopup">
                <div class="helpCenterContent-icon">
                    <img src="@/assets/icons/helpCenterFeedback.svg">
                </div>
                <div class="helpCenterContent-text">{{translate('showFeedbackPopupTitle')}}</div>
            </div>
            <div class="helpCenterContent__wrapper" @click="showAlertsPopup">
                <div class="helpCenterContent-icon">
                    <img src="@/assets/icons/helpCenterAlert.svg">
                </div>
                <div class="helpCenterContent-text">{{translate('showAlertsPopupTitle')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import welcomeModal from '@/components/widgets/welcomeModal';
    import helpPopupMixin from "@/mixins/helpPopupMixin";

    export default {
        name: "helpCenter",
        mixins: [helpPopupMixin],
        components: {
            welcomeModal
        },
        data() {
            return {
                welcomeModalSettings: {}
            }
        },
        methods: {
            showManagePopup() {
                let key = 'manage'
                this.welcomeModalSettings = this.getManagePopupSettings(key), this.welcomeModalSettings.helpCenterSidebar = true
            },
            showFeedbackPopup() {
                let key = 'feedback'
                this.welcomeModalSettings = this.getFeedbackPopupSettings(key), this.welcomeModalSettings.helpCenterSidebar = true
            },
            showAlertsPopup() {
                let key = 'alerts'
                this.welcomeModalSettings = this.getAlertPopupSettings(key), this.welcomeModalSettings.helpCenterSidebar = true
            }

        }
    }
</script>

<style scoped>
    .helpCenterContent__wrapper {
        display: flex;
        align-items: center;
        margin-bottom: 32px;
        cursor: pointer;
    }
    .helpCenterContent {
        margin-top: 20px;
    }
    .helpCenterContent-icon {
        margin-right: 10px;
    }
    .helpCenterContent-text {
        font-size: 16px;
        line-height: 24px;
        color: #1976D2;
    }
</style>